/**
 * ProfilePage — Página completa del perfil del usuario.
 *
 * Se monta dentro del Layout normal (con sidebar). Renderiza ProfileDialog
 * en modo `embedded` (sin overlay ni Portal) usando el query param
 * `?tab=brand|password|profile` para saltar al tab pedido desde
 * shortcuts del dashboard o del certificado.
 */
import { useNavigate, useSearchParams } from "react-router-dom";
import ProfileDialog from "../components/ProfileDialog";

export default function ProfilePage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const tab = params.get("tab") || "profile";

  return (
    <div className="max-w-3xl mx-auto py-2">
      <ProfileDialog
        embedded
        initialTab={tab}
        onClose={() => navigate(-1)}
      />
    </div>
  );
}
